export default __webpack_public_path__ + "24a41d924526405ba8776d4dc5d06ebf.png";